export default __webpack_public_path__ + "static/data-vis-adjacent-color-dont-light-91aadf0cb3bc95656bc0d7d79591f6fe94e1e14333f9c028dc52691b7be2275f.png";